var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('selector-checkboxes',{attrs:{"options":_vm.roles,"label":"Select roles","selected-options":_vm.selectedRoles,"error":_vm.fetchError || _vm.error,"loading":_vm.loading},on:{"on-change":_vm.onChange}})}
var staticRenderFns = []

export { render, staticRenderFns }